export default {
  TABLE: 'TABLE',
  GUEST_LIST: 'GUEST_LIST',
  TALLY: 'TALLY',
  TICKET: 'TICKET'
};



// WEBPACK FOOTER //
// ./src/constants/admissionGroupTypes.js